import React from 'react'
import AgentCard from '../Components/AgentCard'
import Banner from '../Components/Banner'

const Agents = () =>{

    return (
        <React.Fragment>
            <Banner>
                <h2>OUR TEAM</h2>
            </Banner>
            <div className="container pb-5">
                <div className="row">
                    <div className="col-lg-4 mt-3">
                        <AgentCard />
                    </div>
                    <div className="col-lg-4 mt-3">
                        <AgentCard />
                    </div>
                    <div className="col-lg-4 mt-3">
                        <AgentCard />
                    </div>
                    <div className="col-lg-4 mt-3">
                        <AgentCard />
                    </div>
                    <div className="col-lg-4 mt-3">
                        <AgentCard />
                    </div>
                </div>
            </div>
        </React.Fragment>
       
    )
}

export default Agents